import styled from 'styled-components';

export const FeeDeliveryItem = styled.span`
  display: flex;
  text-transform: ${Styles.textTransform.headlines};
  color: ${Styles.color.alert.warning.background};
  font-weight: ${Styles.fontWeight.heavy};
`;

export const Total = styled.span`
  flex-grow: 0;
`;

export const TotalLabel = styled.div<{ isFreeDelivery?: boolean }>`
  flex-grow: 1;
  line-height: 1.7;

  small {
    color: ${Styles.color.grey.one};
  }
  color: ${p => (p.isFreeDelivery ? Styles.color.alert.warning.background : 'inherit')};
  font-weight: ${p => (p.isFreeDelivery ? Styles.fontWeight.heavy : 'inherit')};
`;
